import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  initialized: false,
  user: null,
  isLoading: true,
  isAuthenticated: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setInitialized(state, action) {
      state.initialized = Boolean(action.payload);
    },
    setUser(state, action) {
      state.user = action.payload || null;
    },
    clearUser(state) {
      state.user = null;
    },
    setLoading(state, action) {
      state.isLoading = Boolean(action.payload);
    },
    setAuthenticated(state, action) {
      state.isAuthenticated = Boolean(action.payload);
    },
  },
});

export const { setInitialized, setUser, clearUser, setLoading, setAuthenticated } = appSlice.actions;
export default appSlice.reducer; 